export default "__VITE_ASSET__ClNPuOqS__"